import { combineReducers } from "redux";
import appReducer from "./AppReducer";
import zoomReducer from "./ZoomReducer";
import seekerReducer from "./SeekerReducer";
import AnalyticsReducer from "./AnalyticsReducer";

const rootReducer = combineReducers({
  appReducer,
  zoomReducer,
  seekerReducer,
  AnalyticsReducer,
  // Add more reducers as needed
});

export default rootReducer;
